import componentUtil from '@/commons/componentUtil';
import {onMounted, onUnmounted, getCurrentInstance} from 'vue';

export default function ScrollParent(func, ele) {
  let parents = [];
  const {proxy} = getCurrentInstance();
  ele = ele || 'resize';

  onMounted(() => {
    const element = proxy.$refs[ele];
    parents = componentUtil.getScrollParents(element);

    parents.forEach(pr => pr.addEventListener('scroll', proxy.processScrollParent));
  });

  onUnmounted(() => parents.forEach(pr => pr.removeEventListener('scroll', proxy.processScrollParent)));
}
